<template>
    <div class="tab-pane" id="use-tab-pane">
        <div v-show="selected.showarea==1" class="step step-1 active">
            <div class="row justify-content-center">
                <div class="col-12 col-md-8 py-5 text-center">
                    <h2 class="text-primary font-weight-thin mb-4">{{__('lang.start.tab.actionareas.choose_actioarea')}}</h2>
                </div>
            </div>
            <ul class="row zones list-unstyled">
                <li class="col-6 col-md-3" v-for="(actionarea, idx) in actionareas.filter(item => item.f_filter == 1)" :key="'actionarea_'+actionarea.id" @click="getAppareas(actionarea.actionarea_id)">
                    <div class="card justify-content-end mb-4 rounded-lg" :style="'--bg: url(../mediadata/actionarea/' + actionarea.filename +')'"> <!-- style="--bg: url(../mediadata/actionarea/klassenraum.jpg)" -->
                        <h6 class="text-center card-title m-0 p-3"><a class="stretched-link" data-target="zone-2"
                                type="button">{{actionarea.description_short}}</a></h6>
                    </div>
                </li>
            </ul>
        </div>
        <div  v-show="selected.showarea==2" class="step step-2 active">
            <div class="row justify-content-center">
                <div class="col-12 pt-5">
                    <nav class="zone zone-1" aria-label="breadcrumb">
                        <ol class="breadcrumb bg-transparent px-0 justify-content-center">
                            <li class="breadcrumb-item"><a class="active" role="button" data-reset-step="1" @click="resetActionarea">{{__('lang.start.tab.actionareas.appareas')}}</a></li>
                            <li class="breadcrumb-item">{{selected.actionarea.description_short}}</li>
                        </ol>
                    </nav>

                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-8 pb-5 text-center">
                    <h2 class="text-primary font-weight-thin mb-5">{{__('lang.start.tab.actionareas.choose_apparea')}}</h2>
                </div>
            </div>
                            
            <div class="zone zone-1">
                <ul class="row applications list-unstyled justify-content-center">
                    <li class="col-12 col-md-4"  v-for="(apparea, idx) in appareas.filter(item => item.actionarea_id == selected.actionarea.actionarea_id)" :key="'apparea_'+ apparea.id" @click="getSegments(apparea.apparea_id)">
                        <div :class="'card justify-content-end mb-4 rounded-lg ' + (selected.apparea.apparea_id==apparea.apparea_id ? 'active':'') " :style="'--bg: url(../mediadata/apparea/' + apparea.filename +')'">
                            <h6 class="text-center card-title m-0 p-3">
                                <button class="btn stretched-link" type="button" data-toggle="collapse"
                            :data-target="'#application-1-' + apparea.apparea_id" aria-expanded="false" aria-controls="application-1-1">{{ apparea.description_short }}</button>
                            </h6>
                            <div class="collapse" :id="'application-1-' + apparea.apparea_id" data-parent=".zone-1 .applications">
                                <ul class="list-unstyled mx-3 mb-3">
                                    <li class="mb-2" v-for="(segment, idx) in segments.filter(item => item.apparea_id == selected.apparea.apparea_id)" :key="'segment'+ segment.id"><a class="multiline" data-target="solution-1-1-1" type="button" @click="getCategories(segment.segment_id)">
                                        <svg class="icon">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.arrow" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>{{ segment.description_short }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

          
        </div>
        <div v-show="selected.showarea==3" class="step step-3 active">
            <div class="row justify-content-center">
                <div class="col-12 pt-5">
                    <nav class="solution solution-1-1-1" aria-label="breadcrumb">
                        <ol class="breadcrumb bg-transparent px-0 justify-content-center">
                            <li class="breadcrumb-item"><a class="active" role="button" data-reset-step="1"  @click="resetActionarea">{{__('lang.start.tab.actionareas.appareas')}}</a></li>
                            <li class="breadcrumb-item"><a class="active" role="button" data-reset-step="2"  @click="resetApparea">{{selected.actionarea.description_short}}</a></li>
                            <li class="breadcrumb-item">{{selected.segment.description_short}}</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-8 pb-5 text-center">
                    <h2 class="text-primary font-weight-thin mb-5">{{ __('lang.start.tab.actionareas.choose_op')}}</h2>
                    <operatingpoint ref="app_operatingpoint" parentcontainer="actionarea_tab"></operatingpoint>
                </div>
            </div>
        </div>
    </div>

   
</template>

<script>

import operatingpointApi from './services/api/operatingpointAPI'
import operatingpoint from './OperatingPoint'
export default {
    components: {
        operatingpoint,
    },
    computed: {
        selectedcategories: {
            get() {
                return this.$store.state.operatingpoint.selectedCategories
            },
            set(value) {
                this.$store.commit('operatingpoint/updateSelectedCategories', value)
            }
        },
        contentnav: {
            get() {
                return this.$store.state.globalData.contentnav
            },
            set(value) {
                this.$store.commit('globalData/updateContentnav', value)
            }
        },
      /*   actionarealoaded: {
            get() {
                return this.setOptionsValuesLabels(this.$store.state.operatingpoint.actionarealoaded)
            },
            set(value) {
                this.$store.commit('operatingpoint/updateactionarealoaded', value);
            }
        }, */
       
    },
    data() {
        return {
            actionareas: [],
            appareas: [],
            segments: [],
            categories: [],
            selected: {
                showarea: 1,
                actionarea: {},
                apparea: {},
                segment: {
                },

            }
        }
    },
    methods: {
        async getActionareas() {
            var body = []

            body.push({
                language_id: this.$lang().locale, //navigator.language,
            })
            var response = await operatingpointApi.getActionareas(body);
            this.actionareas = response.actionareas;
           
           //this.$store.commit('operatingpoint/setActionareas', response.actionareas)
            //console.log(response.actionareas);

        },  
        async getAppareas(actionarea_id) { 
            var body = []

            body.push({
                language_id: this.$lang().locale, //navigator.language,
                actionarea_id: actionarea_id
            })
            var response = await operatingpointApi.getAppareas(body);
            this.appareas = response.appareas;
            //console.log(response.appareas);
            this.selected.showarea = 2

            this.selected.actionarea = Object.assign({},this.actionareas.filter(actionarea => actionarea.actionarea_id == actionarea_id)[0])
           
        },
        async getSegments(apparea_id) {
            var body = []

            body.push({
                language_id: this.$lang().locale, //navigator.language,
                apparea_id: apparea_id
            })
            var response = await operatingpointApi.getSegments(body);
            this.segments = response.segments;


            this.selected.apparea = Object.assign({}, this.appareas.filter(apparea => apparea.apparea_id == apparea_id)[0])
            
            //console.log(this.selected.apparea);
           

        },
        async getCategories(segment_id) {
            var body = []
            var selectedcatsfromsegment
            var filter = 0;
            body.push({
                language_id: this.$lang().locale, //navigator.language,
                segment_id: segment_id,
                filter: filter
            })
            
            var response = await operatingpointApi.getSegmentCategories(body);
            var selectedcatsfromsegment = response.categories;
            this.categories = selectedcatsfromsegment //response.categories;

            var selectedcatsfromsegment = response.categories.filter(cat=>cat.f_filter==1)
/* 
            console.log('fromsegment')
            console.log(selectedcatsfromsegment)
            console.log('selectedcatsfromsegment.length')
            console.log(selectedcatsfromsegment.length) */
 

 
            if (selectedcatsfromsegment.length > 0) {
                var filter = 1;
            }   
            else{
                var selectedcatsfromsegment = response.categories.filter(cat => cat.f_filter == 0)
                //this.showProductList(segment_id)
                var filter = 0;
                
            }


            var bodyallcats = []
            var cats_desc = []


            bodyallcats.push({
                language_id: this.$lang().locale, //navigator.language,
                filter: filter
               
            })
        /*     console.log('getCategories bodyallcats')
            console.log(bodyallcats) */
            var response = await operatingpointApi.getCategories(bodyallcats);
            var allCategories = response.categories;
            /* 
            var allCategories = allcategories.map(function (categories) {

                return categories.subcategories

            }) 
 */

           /*  var cats = this.categories.map(function (categories) {
                //cats in filter:
                var subcats = categories.subcategories.filter(subcatitem => subcatitem.f_filter == 1)
                return {
                    catparentid: categories.id,
                    countsubcats: countsubcats
                };
            }) */
            var selected = []
/* 
            console.log('selectedcatsfromsegment:')
            console.log(selectedcatsfromsegment)
            if(selectedcatsfromsegment.some(cat => cat.category_id === 302)) console.log('302') */
            

            allCategories.forEach(function (catlevel1) {
                if (catlevel1.subcategories.length > 0) {

                    catlevel1.subcategories.forEach(function (catlevel2) {
                        if (selectedcatsfromsegment.some(cat => cat.category_id === catlevel2.categoryChildId)) {
                            selected[catlevel2.categoryChildId] = true
                            var cd = {}
                            Object.assign(cd, {
                                id: catlevel2.category_id,
                                desc: catlevel2.description_short
                            })
                            cats_desc.push(cd);
                            



                        }
                        else selected[catlevel2.categoryChildId] = false
                    })
                }
            });
            this.$store.commit('operatingpoint/updateSelectedCategories', selected);

            this.$store.commit('operatingpoint/setDescSelectedCategories', cats_desc);
            /* this.$store.commit('operatingpoint/updateSelectedTmpCategories', tmpcategories) */



            this.selected.segment = Object.assign({}, this.segments.filter(segment => segment.segment_id == segment_id)[0])
            if (filter == 1) this.selected.showarea = 3  //to op
            else this.$root.$refs.main.listenerchild({ nav: "2", searchflag: "apparea" }); // show productlist
         },
        resetActionarea: function () {
            this.selected =  {
                    showarea: 1,
                    actionarea: {},
                    apparea: {},
                    segment: {},

            }
        },
        resetApparea: function () {
            Object.assign(this.selected, {
                showarea: 2,
                
            });
        },
        
        
        
    },
    mounted() {
       
    }
}
</script>
<style scoped>

.zone > ul.applications > li {
  pointer-events: none;
}

.zone > ul.applications > li ul.list-unstyled {
  pointer-events: all;
}


</style>
